import React, { useContext } from 'react'
import styled from 'styled-components'

import companyIcon from '../../images/svg/companyIcon.svg';

import { SalleContext } from '../../context/salle'
const CardWrapper = styled.div`
    width: 100%;
    min-height: 90px;
    
    margin-bottom: 1rem;
    .textPrimary{
        font-size: 1.2rem;
        font-family: "Poppins";
        font-weight: 600;
        height:0.2rem;
    }
    border-bottom:1px solid #5A5A5A;

`
const CardItems = styled.div`
    margin-top: 1.8rem;
    display: flex;
    align-items: center;
`
const ButtonStatus = styled.button`
    font-family: "Poppins";
    font-weight: 600;
    margin-top:0rem;
    margin-left:0.4rem;
    display:flex;
    align-items: center;
    justify-content: center;
    width:81px;
    font-size:12px;
    height:22px;
    background-color: #373839;
    border:none;
    outline: none;
    border-radius: 10px;
    color:#CFCFCF;
`
const CircleButton = styled.div`
    margin-top: 0.1rem;
    margin-right: 0.2rem;
    width: 8px;
    height: 8px;
    border-radius: 100px;
    background-color: ${props => props.status == null ? "#E7BE00" : props.status == 5 ? "#4ad754" :  props.status == 6 ? "#e86f6c" : props.status ==  4 ? "#2a8df5" : props.status == 2 ? "#ff633b" :  ""};

`
const CardCircle = styled.div`
    display:flex;
    justify-content: center;
    align-items:center;
    width:22px;
    height:22px;
    border-radius: 100px;
    background-color: ${props => props.status == null ? "#E7BE00" : props.status == 5 ? "#4ad754" : props.status == 2 ? "#ff633b" : props.status == 6 ? "#e86f6c" :  props.status ==  4 ? "#2a8df5" :""};

`
const CardCircleTkg = styled.div`
    display:flex;
    justify-content: center;
    align-items:center;
    width:22px;
    height:22px;
    border-radius: 100px;
    background-color: white;

`
const ImageIcon = styled.img`
    margin-top:0rem;
    margin-left: 0.1rem;
    width:35px;
    object-fit: cover;
    height:22px;
    border-radius:100px;

`

const CardSaleStatusTiny = ({ status }) => {
    const { salleStatus } = useContext(SalleContext)
    return (
        <CardWrapper>
            <p className='textPrimary'>Pedido de Venda</p>
            <CardItems>
                <CardCircle status={salleStatus}>
                    <svg width="13" height="13" viewBox="0 0 13 13" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M8.61965 2.54566C9.43809 2.54566 10.4536 2.26551 11.6661 1.70521C11.8479 1.61435 12.0222 1.62192 12.1889 1.72792C12.3557 1.83393 12.439 1.99293 12.439 2.20494V8.13351C12.439 8.33037 12.3557 8.4818 12.1889 8.58781C11.2341 9.23897 10.2489 9.56455 9.23348 9.56455C8.68785 9.56455 8.00203 9.43204 7.17602 9.16704C6.35 8.90203 5.73996 8.76953 5.3459 8.76953C4.2395 8.76953 3.20887 8.9891 2.25403 9.42826V12.1995C2.25403 12.3812 2.16309 12.472 1.98121 12.472H1.79934C1.61746 12.472 1.52653 12.3812 1.52653 12.1995V2.95453C1.29918 2.87881 1.11731 2.74252 0.980901 2.54566C0.844495 2.3488 0.78387 2.12165 0.799026 1.86421C0.814183 1.59164 0.924065 1.35692 1.12867 1.16005C1.33328 0.963192 1.572 0.857189 1.84481 0.842046C2.17825 0.826903 2.46242 0.944263 2.69735 1.19413C2.93227 1.44399 3.027 1.7355 2.98153 2.06865C3.52715 1.85664 4.11067 1.75064 4.73207 1.75064C5.2777 1.75064 5.96352 1.88314 6.78953 2.14815C7.61555 2.41316 8.22559 2.54566 8.61965 2.54566ZM2.20856 1.61435C2.20856 1.61435 2.18582 1.59164 2.14035 1.54621C2.09489 1.50078 2.01153 1.47806 1.89028 1.47806C1.76903 1.47806 1.66293 1.52349 1.572 1.61435C1.48106 1.70521 1.43559 1.81121 1.43559 1.93236C1.43559 2.0535 1.48106 2.15951 1.572 2.25037C1.66293 2.34123 1.76903 2.38666 1.89028 2.38666C2.01153 2.38666 2.11762 2.34123 2.20856 2.25037C2.2995 2.15951 2.34496 2.0535 2.34496 1.93236C2.34496 1.81121 2.2995 1.70521 2.20856 1.61435ZM11.7115 8.04265V2.47751C10.6051 3.00753 9.5745 3.27253 8.61965 3.27253C8.14981 3.27253 7.50188 3.14003 6.67586 2.87502C5.84985 2.61002 5.20192 2.47751 4.73207 2.47751C3.80754 2.47751 2.98153 2.74252 2.25403 3.27253V8.63324C3.08762 8.23951 4.11825 8.04265 5.3459 8.04265C5.81575 8.04265 6.46368 8.17515 7.28969 8.44016C8.11571 8.70517 8.76364 8.83767 9.23348 8.83767C10.158 8.83767 10.984 8.57266 11.7115 8.04265Z" fill="#454545" />
                    </svg>

                </CardCircle>
                <CardCircleTkg>
                    <ImageIcon src={companyIcon}/>
                </CardCircleTkg>
                <ButtonStatus><CircleButton status={salleStatus} /> {salleStatus == "5" ? "enviado" : salleStatus == 2  ? "separando" : salleStatus == "4" ? "embalando" : salleStatus == "6" ? "cancelado" :  "em aberto"}</ButtonStatus>
            </CardItems>
        </CardWrapper>
    )

}

export default CardSaleStatusTiny